export default class InvalidPasswordError extends Error {
  email?: string;

  constructor(email?: string) {
    super(`Invalid password for email: ${email}`);

    this.email = email;
  }
}
